import { IsNotEmpty, IsString } from 'class-validator';
import { v4 as uuid } from 'uuid';

export class BaseRule {
  constructor() {
    this.key = uuid();
  }

  @IsNotEmpty()
  @IsString()
  id!: string;

  key!: string;
}
